import DateUtils from "../../../shared/utils/DateUtils";
import MonetaryUtils from "../../../shared/utils/MonetaryUtils";
import { hasValue } from "../../utils/pacto-rebates-utils";
import { isValidPercentageNumber } from "./admin-utils";

export const formatAdjustmentPayload = ({
	effectiveStartDate,
	effectiveEndDate,
	adjustment
}) => {
	
	return {
		inicioVigencia: DateUtils.formatDateToAmerican(effectiveStartDate),
		terminoVigencia: DateUtils.formatDateToAmerican(effectiveEndDate),
        percentualReajuste: MonetaryUtils.parseDecimal(adjustment)
	};
};

export const formatAdjustmentResponse = adjustment => ({
	id: adjustment.id,
	effectiveStartDate: adjustment.inicioVigencia,
	effectiveEndDate: adjustment.terminoVigencia,
	adjustment: adjustment.percentualReajuste,
	createdAt: adjustment.dataCriacao,
	updatedAt: adjustment?.dataUltimaAtualizacao
});

export const validateAdjustmentPayload = values => {
	const errors = {};

	if (!hasValue(values.effectiveStartDate)) {
		errors.effectiveStartDate = "Informe a data de início da vigência.";
	} else if (!DateUtils.isDateAfterToday(values.effectiveStartDate)) {
		errors.effectiveStartDate = "A data de início da vigência deve ser maior que a data atual.";
	}

	if (!hasValue(values.effectiveEndDate)) {
		errors.effectiveEndDate = "Informe a data de término da vigência.";
	}

	if (
		hasValue(values.effectiveStartDate) &&
		hasValue(values.effectiveEndDate) &&
		!DateUtils.isDateAfterOrEqual(
			values.effectiveEndDate,
			values.effectiveStartDate
		)
	) {
		const invalidDateRangeMessage =
			"A data de início da vigência não pode ser maior que a data de término da vigência.";

		errors.effectiveStartDate = invalidDateRangeMessage;
		errors.effectiveEndDate = invalidDateRangeMessage;
	}

	if (!hasValue(values.adjustment)) {
    	errors.adjustment = "Informe o percentual de reajuste.";
	} else if (!isValidPercentageNumber(values.adjustment)) {
		errors.adjustment = "O percentual de reajuste deve ter até 5 casas, sendo até 2 decimais.";
	} else if (MonetaryUtils.parseDecimal(values.adjustment) <= 0) {
		errors.adjustment = "O percentual de reajuste deve ser maior que zero.";
	}

	return errors;
};